import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Check, X } from "lucide-react";
import { toast } from "sonner";

export default function AdminVerifications() {
  const [status, setStatus] = useState("pending");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get(`/admin/verifications?status=${status}`).then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [status]);

  const approve = async (id) => {
    try { await api.post(`/admin/verifications/${id}/approve`); toast.success("Approved"); load(); }
    catch { toast.error("Failed"); }
  };
  const reject = async (id) => {
    try { await api.post(`/admin/verifications/${id}/reject`); toast.success("Rejected"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="p-6 lg:p-10">
      <div className="border-b border-border pb-6 mb-8 flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="label-mono text-muted-foreground mb-1">Aadhaar / DigiLocker</div>
          <h1 className="font-serif text-4xl">Verifications</h1>
        </div>
        <div className="border border-border">
          {["pending", "approved", "rejected"].map((s) => (
            <button
              key={s}
              onClick={() => setStatus(s)}
              data-testid={`admin-ver-tab-${s}`}
              className={`label-mono px-5 py-2.5 transition-colors ${status === s ? "bg-foreground text-background" : "text-muted-foreground hover:bg-secondary"}`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="label-mono text-muted-foreground">Loading…</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-border p-16 text-center label-mono text-muted-foreground">
          No {status} verifications
        </div>
      ) : (
        <div className="grid gap-3">
          {items.map((v) => (
            <div key={v.id} className="border border-border p-5 flex items-center gap-4 flex-wrap" data-testid={`ver-row-${v.id}`}>
              <div className="w-12 h-12 rounded-sm bg-secondary border border-border flex items-center justify-center font-mono">
                {v.user?.username?.[0]?.toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm">@{v.user?.username}</div>
                <div className="label-mono text-muted-foreground">{v.full_name} · {v.aadhaar_number_masked}</div>
                <div className="label-mono text-muted-foreground text-[10px] mt-1">
                  Submitted: {new Date(v.submitted_at).toLocaleString()}
                </div>
              </div>
              {status === "pending" && (
                <div className="flex gap-2">
                  <Button onClick={() => approve(v.id)} className="rounded-sm label-mono bg-[hsl(var(--support))] text-background hover:bg-[hsl(var(--support))]/90" data-testid={`approve-ver-${v.id}`}>
                    <Check className="w-4 h-4 mr-2" /> Approve
                  </Button>
                  <Button onClick={() => reject(v.id)} variant="outline" className="rounded-sm label-mono border-[hsl(var(--oppose))] text-[hsl(var(--oppose))] hover:bg-[hsl(var(--oppose))] hover:text-white" data-testid={`reject-ver-${v.id}`}>
                    <X className="w-4 h-4 mr-2" /> Reject
                  </Button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
